import React from 'react';
import type { DashboardStats } from '../../models/DashboardStats';
import { NoShowsWidget } from '../NoShows';
import { UserRankingWidget } from '../UserRanking';
import { HourlyHeatmap } from '../HourlyHeatmap';

interface DashboardLayoutCAProps {
  data: DashboardStats;
}

export const DashboardLayoutCA: React.FC<DashboardLayoutCAProps> = ({
  data,
}) => (
  <>
    <div className='md:col-span-2 lg:col-span-2'>
      <NoShowsWidget data={data.noShows} />
    </div>
    <div className='lg:col-span-1'>
      <UserRankingWidget data={data.usersRanking} />
    </div>
    <div className='md:col-span-2 lg:col-span-3 min-h-[300px]'>
      <HourlyHeatmap data={data.heatmap} />
    </div>
  </>
);
